import { Controller } from "@hotwired/stimulus"

// Shows a saving/saved icon indicator on auto-saving forms.
//
// Usage:
//   <form data-controller="save-status">
//     <textarea data-action="input->save-status#changed"></textarea>
//     <div data-save-status-target="indicator" class="hidden">
//       <svg data-save-status-target="spinner" ...></svg>
//       <svg data-save-status-target="check" class="hidden" ...></svg>
//     </div>
//   </form>
export default class extends Controller {
  static targets = ["indicator", "spinner", "check"]

  connect() {
    this.hideTimeout = null
    this.element.addEventListener("turbo:submit-end", this.onEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.onEnd)
    if (this.hideTimeout) clearTimeout(this.hideTimeout)
  }

  changed() {
    if (this.hideTimeout) clearTimeout(this.hideTimeout)
    this.showSpinner()
  }

  onEnd = (event) => {
    const success = event.detail?.success !== false
    if (success) {
      this.showCheck()
    }
    this.hideTimeout = setTimeout(() => this.hide(), 2000)
  }

  showSpinner() {
    if (!this.hasIndicatorTarget) return
    this.indicatorTarget.classList.remove("hidden")
    this.spinnerTarget.classList.remove("hidden")
    this.checkTarget.classList.add("hidden")
  }

  showCheck() {
    if (!this.hasIndicatorTarget) return
    this.indicatorTarget.classList.remove("hidden")
    this.spinnerTarget.classList.add("hidden")
    this.checkTarget.classList.remove("hidden")
  }

  hide() {
    if (!this.hasIndicatorTarget) return
    this.indicatorTarget.classList.add("hidden")
  }
}
